// Офлайн-кэш режима «визитка»: тонкая обёртка над localStorage.
// Приложением пользуются на конференциях, где связь пропадает регулярно, а показать
// QR собеседнику нужно именно там и именно тогда. Кэш read-through: сохранённое
// показывается, пока не пришёл свежий ответ, и остаётся, если он не придёт вовсе.
//
// Service worker / IndexedDB намеренно не используются: объём — один небольшой ответ,
// а любая из этих технологий добавляет свой жизненный цикл и свои способы сломаться
// внутри WebView.
//
// TTL нет: QR устаревает, только когда человек сам правит анкету (после сохранения
// VCardTab перезапрашивает ручку и перетирает запись). Без связи прошлогодний QR
// всё равно полезнее пустого экрана.

// Префикс, чтобы dropCache() чистил своё, не задев token, user, navic_lang и прочее.
const PREFIX = "nc_cache_";

// Версия раскладки записи: при её смене старые записи игнорируются, а не роняют экран.
const VERSION = 1;

export const CACHE_VCARD_QR = "vcard_qr";

// → { v, savedAt, data } или null. Кэша нет, кэш битый, кэш от старой версии —
// для вызывающего всё это одинаково «кэша нет».
export function readCache(key) {
  try {
    const raw = localStorage.getItem(PREFIX + key);
    if (!raw) return null;

    const entry = JSON.parse(raw);
    if (!entry || entry.v !== VERSION || !entry.data) return null;

    return entry;
  } catch (e) {
    return null;
  }
}

export function writeCache(key, data) {
  try {
    const entry = { v: VERSION, savedAt: Date.now(), data };
    localStorage.setItem(PREFIX + key, JSON.stringify(entry));
  } catch (e) {
    // QuotaExceededError или приватный режим — кэш необязательная роскошь,
    // молча живём без него.
  }
}

// Вызывается при каждой смене аккаунта — там же, где сбрасывается localStorage.user.
export function dropCache() {
  try {
    const keys = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      // indexOf, а не startsWith: старые WebView, полифилов в сборке нет.
      if (key && key.indexOf(PREFIX) === 0) keys.push(key);
    }
    // Удаляем вторым проходом: removeItem внутри обхода сдвигает индексы.
    keys.forEach((key) => localStorage.removeItem(key));
  } catch (e) {
    // localStorage недоступен — чистить нечего.
  }
}
